import Axios from 'axios'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { API_URL } from '../config'

const CheckUserLogin = () => {
  const history = useHistory()

  useEffect(() => {
    let cancelled = false

    const hasId = ['businessid', 'partnerid', 'customerid'].some((k) => localStorage.getItem(k))

    if (!hasId) {
      console.warn('[auth] redirect: no account id in localStorage')
      history.push('/login')
      return
    }

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=ACCOUNTTYPE`, {
      withCredentials: true,
    })
      .then((response) => {
        if (!cancelled && response.data.account_type === 'guest') {
          console.warn('[auth] redirect: server reports guest', response.data)
          localStorage.clear()
          history.push('/login')
        }
      })
      .catch((err) => {
        console.error('[auth] session check failed (not logging out):', err)
      })

    return () => {
      cancelled = true
    }
  }, [])

  return null
}

export { CheckUserLogin }
